/**
 * UserOutlineIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const UserOutlineIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M16 14.1c2.697 0 4.9 2.203 4.9 4.9v1c0 1.047-.853 1.9-1.9 1.9H5c-1.047 0-1.9-.853-1.9-1.9v-1c0-2.697 2.203-4.9 4.9-4.9zm-8 1.8A3.11 3.11 0 0 0 4.9 19v1q0 .039.03.07.031.03.07.03h14q.039 0 .07-.03.03-.031.03-.07v-1c0-1.703-1.397-3.1-3.1-3.1zm4-13.8a5.394 5.394 0 0 1 5.383 5.383c0 2.957-2.41 5.417-5.383 5.417a5.394 5.394 0 0 1-5.383-5.383C6.617 4.56 9.027 2.1 12 2.1m0 1.8c-1.961 0-3.583 1.637-3.583 3.617A3.594 3.594 0 0 0 12 11.1c1.961 0 3.583-1.637 3.583-3.617A3.594 3.594 0 0 0 12 3.9"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const UserOutlineIcon = makeIcon('UserOutlineIcon', UserOutlineIconSvg)
